import type { TrackedPageRoute } from '@wundo/shared/pageVisit.ts';

export type PageSection =
  | 'Agenda'
  | 'Meetings'
  | 'Practice'
  | 'Team'
  | 'Journeys'
  | 'Settings'
  | 'Dashboard'
  | 'Onboarding';

export interface TrackedPage {
  label: string;
  section: PageSection;
}

/** The day the web app started reporting page visits; nothing before it was counted. */
export const PAGE_USAGE_TRACKED_SINCE = '7 Oct 2026';

/** The web app's pages as a person would name them, keyed by route pattern. */
export const TRACKED_PAGES: Record<TrackedPageRoute, TrackedPage> = {
  '/': { label: 'Agenda', section: 'Agenda' },
  '/meetings/$meetingId': { label: 'Meeting', section: 'Meetings' },
  '/conversations': { label: 'Conversations', section: 'Meetings' },
  '/contacts': { label: 'Contacts', section: 'Team' },
  '/team/': { label: 'Team', section: 'Team' },
  '/team/$colleagueId': { label: 'Colleague', section: 'Team' },
  '/journeys/': { label: 'Journeys', section: 'Journeys' },
  '/journeys/$journeyId': { label: 'Journey', section: 'Journeys' },
  '/dashboard': { label: 'Dashboard', section: 'Dashboard' },
  '/practice/': { label: 'Practice library', section: 'Practice' },
  '/practice/new': { label: 'New practice', section: 'Practice' },
  '/practice/$roleplayId/': { label: 'Practice scenario', section: 'Practice' },
  '/practice/$roleplayId/edit': { label: 'Edit practice', section: 'Practice' },
  '/practice/session/$sessionId': { label: 'Practice session', section: 'Practice' },
  '/settings/profile': { label: 'Profile', section: 'Settings' },
  '/settings/agenda': { label: 'Agenda settings', section: 'Settings' },
  '/settings/connections': { label: 'Connections', section: 'Settings' },
  '/settings/meetings': { label: 'Meeting settings', section: 'Settings' },
  '/settings/notifications': { label: 'Notifications', section: 'Settings' },
  '/settings/templates': { label: 'Templates', section: 'Settings' },
  '/$': { label: 'Page not found', section: 'Agenda' },
  '/onboarding/welcome': { label: 'Welcome', section: 'Onboarding' },
  '/onboarding/what-you-get': { label: 'What you get', section: 'Onboarding' },
  '/onboarding/how-it-works': { label: 'How it works', section: 'Onboarding' },
  '/onboarding/calendar': { label: 'Calendar', section: 'Onboarding' },
  '/onboarding/colleagues': { label: 'Colleagues', section: 'Onboarding' },
  '/onboarding/first-meeting': { label: 'First meeting', section: 'Onboarding' },
  '/onboarding/ready-to-practise': { label: 'Ready to practise', section: 'Onboarding' },
};

/** The onboarding steps in the order the web app walks a newcomer through them. */
export const ONBOARDING_STEPS: TrackedPageRoute[] = [
  '/onboarding/welcome',
  '/onboarding/what-you-get',
  '/onboarding/how-it-works',
  '/onboarding/calendar',
  '/onboarding/colleagues',
  '/onboarding/first-meeting',
  '/onboarding/ready-to-practise',
];
